export default "__VITE_ASSET__mYjlld9yTZoInsyi6McoVQ__"